import { FC } from 'react'
import { Box } from '@mui/material'
import Navbar from '../Navbar'
import { IMainLayout } from './types'

const MainLayout: FC<IMainLayout> = ({ className = '', children, childrenSx = {} }) => {
  return (
      <Box bgcolor='background.paper' className={`t-viewport ${className}`}>
        <Navbar />
        <Box sx={{ ...childrenSx }} className={'t-viewport-body'}>
          {children}
        </Box>
      </Box>
  )
}

export default MainLayout
